export const num2name = {
    0: "NULL_VALUE",
};
export const name2num = {
    NULL_VALUE: 0,
};
